import { Grid } from "@mui/material"
import React from "react"
import {
	ReportDateRangeExecutionField,
	ReportEmailField,
	ReportFrequencyDaysField,
	ReportFrequencyHoursField,
	ReportManualExecutionSwitch
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import ReportFormSectionDivider from "Pages/ReportsAlerts/Reports/@components/FormDrawer/SectionDivider"

export default function ReportFormDrawerFrequencySection() {
	return <Grid container spacing={2}>
		<Grid item xs={2}>
			<ReportFormSectionDivider title="Frequency & Notification" icon="circle-play"/>
		</Grid>
		<Grid item xs={10}/>
		<Grid item xs={6} data-tour-id="tour-email">
			<ReportEmailField/>
		</Grid>
		<Grid item xs={5}/>
		<Grid item xs={3} data-tour-id="tour-exec-frequency">
			<ReportFrequencyHoursField/>
		</Grid>
		<Grid item xs={3} data-tour-id="tour-frequencies">
			<ReportFrequencyDaysField/>
		</Grid>
		<Grid item xs={2}>
			<ReportManualExecutionSwitch/>
		</Grid>
		<Grid item xs={5}>
			<ReportDateRangeExecutionField/>
		</Grid>
	</Grid>
}
